import { Skeleton } from '@elements/skeleton'
import { Link } from '@elements/link'
import { Button } from '@elements/button'
import { H3 } from '@elements/headings'

import { InventoryCard } from './inventory-card'
import { InventoryItem, Venue } from 'types/model'

export interface InventoryListingProps {
  title?: string
  inventory?: InventoryItem[]
  venue?: Venue
  onInventoryAdd?: (inv: InventoryItem) => void | Promise<void>
  externalLink?: string
  loading?: boolean
}

export function InventoryListing({
  title,
  loading = false,
  externalLink,
  onInventoryAdd,
  inventory = [],
  venue,
}: InventoryListingProps) {
  const noInventory = !externalLink && !inventory.length && !loading

  if (noInventory || !venue) return null
  return (
    <div className="flex flex-col items-start justify-center w-full px-3 space-y-3 transition-all h-fit">
      {!loading && title && <H3 className="heading-lg">{title}</H3>}
      {!loading && externalLink && (
        <Link href={externalLink} className="w-full" target="_blank" rel="noreferrer">
          <Button.Primary className="w-full">Get {title}</Button.Primary>
        </Link>
      )}
      {!loading &&
        inventory?.map((inv) => (
          <InventoryCard key={inv.id} venue={venue} inventory={inv} onAdd={onInventoryAdd} />
        ))}
      {loading && (
        <>
          <Skeleton className="w-24 h-6" />
          <InventoryCard.Skeleton />
          <InventoryCard.Skeleton />
          <InventoryCard.Skeleton />
        </>
      )}
    </div>
  )
}
